module.exports = __webpack_public_path__ + "static/media/cm.e97d922e.svg";